module.exports = __webpack_public_path__ + "static/full-width-image-twohands-468207b3e966fa936f2f8ea7f635f2bc.jpg";